/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportCommentFormLocal = {
    readonly dsaFeaturesEnabled: boolean | null;
    readonly " $refType": "ReportCommentFormLocal";
};
export type ReportCommentFormLocal$data = ReportCommentFormLocal;
export type ReportCommentFormLocal$key = {
    readonly " $data"?: ReportCommentFormLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportCommentFormLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportCommentFormLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dsaFeaturesEnabled",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'f574563bf935d8c1f19de80bc95546c0';
export default node;
